import { ROLLER_TYPE } from "../enum/ROLLER_TYPE";

/**
 * Which options a configurator offers in an exterior slot. The option
 * database lists them by kind only, but not every option of a kind fits
 * every slot that takes the kind.
 */

/**
 * Whether a corner may be chosen for the top of the case. A stacking corner
 * (`forceOrientation`) is always built at the bottom, so one chosen for the
 * top would be built upside down.
 */
export function isCornerAllowedOnTop(option: object): boolean {
  return !("forceOrientation" in option && option.forceOrientation);
}

/**
 * Whether a roller may be chosen as the exterior roller of the case. A floor
 * caster (`ROLLER_TYPE.CREEPER`) is only mounted through a roller board.
 */
export function isExteriorRollerOption(option: object): boolean {
  return !("rollerType" in option && option.rollerType === ROLLER_TYPE.CREEPER);
}
